import { IsBoolean, IsOptional, IsString, MaxLength } from 'class-validator';

export class EquipmentActiveStateDto {
  @IsBoolean()
  active!: boolean;

  @IsString()
  @IsOptional()
  @MaxLength(120)
  label?: string;
}
